/**
 * Triggers the download of a file fetched from an API call
 *
 * @param filename the name of the file to download
 * @param response the blob response from the server
 */
export function downloadFile(filename, response) {
    const fileURL = window.URL.createObjectURL(new Blob([response]));
    const fileLink = document.createElement("a");
    fileLink.href = fileURL;
    fileLink.setAttribute("download", filename);
    const child = document.body.appendChild(fileLink);
    fileLink.click();
    document.body.removeChild(child);
}
